<template>
  <q-card flat bordered class="q-ma-xs q-ml-md-sm q-mr-none">
    <q-tabs
      v-model="tabTurnover"
      dense
      outside-arrows
      mobile-arrows
      :class="
        this.$q.dark.mode === true ? 'bg-grey-10' : 'text-grey-9 bg-grey-4'
      "
      active-color="white"
      :active-bg-color="activeTabColorFromUtils()"
      :indicator-color="'white'"
      align="justify"
      narrow-indicator
    >
      <q-tab name="top_turnover" label="Top Turnover" no-caps />
      <q-tab name="top_volume" label="Top Volume" no-caps />
      <q-tab name="top_transaction" label="Top Transaction" no-caps />
    </q-tabs>
    <q-separator />

    <q-tab-panels v-model="tabTurnover" animated class="flex">
      <q-tab-panel class="q-pa-none" name="top_turnover">
        <div
          v-if="theme == false"
          class="q-my-xs text-bold text-center"
          :class="this.$q.dark.mode === true ? '' : 'text-primary '"
        >
          Top Turnover
        </div>

        <q-table
          style="box-sizing: content-box"
          :rows="topTurnover"
          :columns="columnsTurnover"
          :pagination="{
            sortBy: 'amount',
            descending: true,
            rowsPerPage: 10,
          }"
          hide-bottom
          dense
          separator="cell"
          :class="
            $q.dark.mode
              ? 'table-sticky-header-column-dark'
              : 'table-sticky-header-column'
          "
        >
          <template v-slot:body-cell-symbol="props">
            <q-td :props="props">
              <q-item
                class="q-pa-none q-ma-none"
                dense
                clickable
                :to="{
                  path: '/stock-profile',
                  query: { symbol: props.value },
                }"
              >
                {{ props.value }}
                <q-tooltip>{{
                  allStocks.find((stock) => stock.symbol == props.value).name
                }}</q-tooltip>
              </q-item>
            </q-td>
          </template>
        </q-table></q-tab-panel
      >
      <q-tab-panel class="q-pa-none" name="top_volume">
        <div
          v-if="theme == false"
          class="q-my-xs text-bold text-center"
          :class="this.$q.dark.mode === true ? '' : 'text-primary '"
        >
          Top Volume
        </div>
        <q-table
          style="box-sizing: content-box"
          :rows="topVolume"
          :columns="columnsVolume"
          :pagination="{
            sortBy: 'volume',
            descending: true,
            rowsPerPage: 10,
          }"
          hide-bottom
          dense
          separator="cell"
          :class="
            this.$q.dark.mode === true
              ? 'table-sticky-header-column-dark'
              : 'table-sticky-header-column'
          "
        >
          <template v-slot:body-cell-symbol="props">
            <q-td :props="props">
              <q-item
                class="q-pa-none q-ma-none"
                dense
                clickable
                :to="{
                  path: '/stock-profile',
                  query: { symbol: props.value },
                }"
              >
                {{ props.value }}
              </q-item>
            </q-td>
          </template>
        </q-table>
      </q-tab-panel>
      <q-tab-panel class="q-pa-none" name="top_transaction">
        <div
          v-if="theme == false"
          class="q-my-xs text-bold text-center"
          :class="this.$q.dark.mode === true ? '' : 'text-primary '"
        >
          Top Transactions
        </div>
        <q-table
          style="box-sizing: content-box"
          :rows="topTransaction"
          :columns="columnsTransaction"
          :pagination="{
            sortBy: 'count',
            descending: true,
            rowsPerPage: 10,
          }"
          hide-bottom
          dense
          separator="cell"
          :class="
            this.$q.dark.mode === true
              ? 'table-sticky-header-column-dark'
              : 'table-sticky-header-column'
          "
        >
          <template v-slot:body-cell-symbol="props">
            <q-td :props="props" class="q-pa-none q-ma-none">
              <q-item
                class="q-pa-none q-ma-none"
                dense
                clickable
                :to="{
                  path: '/stock-profile',
                  query: { symbol: props.value },
                }"
              >
                {{ props.value }}
              </q-item>
            </q-td>
          </template>
        </q-table>
      </q-tab-panel>
    </q-tab-panels>
  </q-card>
</template>
<script>
import { ref, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import useData from "src/use/data";
import useUtils from "src/use/utils";
import { LocalStorage, useQuasar } from "quasar";

export default {
  name: "LiveMarketTopTab",
  components: {},
  props: {
    allStocks: { type: Array },
    topTransaction: { Array },
    topVolume: { Array },
    topTurnover: { Array },
    theme: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const store = useStore();
    const $q = useQuasar();

    const {
      intraStockPerformance,
      stockPerformance,
      floorsheetSearchByDate,
      intradayFloorsheetSearchByDate,
    } = useData();
    const { amountConversion, chooseTabColor, chooseActiveTabColor } =
      useUtils();

    const isMarketOn = ref(false);
    const asOf = ref(store.state.market.asOf);
    const asOfLive = ref(store.state.market.asOfLive);
    isMarketOn.value = store.state.market.marketStatus;

    let intervalId = null;

    function tablethreadColor() {
      return chooseTabColor(
        $q.dark.mode,
        store.state.domain.domain,
        store.state.domain.sweta,
        store.state.domain.chukul,
        store.state.domain.prabhu,
        store.state.domain.arthasarokar
      );
    }
    function chooseColorFromUtils() {
      return chooseTabColor(
        $q.dark.mode,
        store.state.domain.domain,
        store.state.domain.sweta,
        store.state.domain.chukul,
        store.state.domain.prabhu,
        store.state.domain.arthasarokar
      );
    }
    function activeTabColorFromUtils() {
      return chooseActiveTabColor(
        $q.dark.mode,
        store.state.domain.domain,
        store.state.domain.sweta,
        store.state.domain.chukul,
        store.state.domain.prabhu,
        store.state.domain.arthasarokar
      );
    }

    const columnsTurnover = [
      {
        name: "symbol",
        label: "Symbol",
        field: "symbol",
        align: "center",
        style: "display:flex;max-width:100vw;justify-content: center;",
      },
      {
        name: "amount",
        label: "Turnover",
        field: "amount",
        align: "center",
        format: (val, row) => {
          return amountConversion(val);
        },
      },
      {
        name: "close",
        label: "LTP",
        field: "close",
        align: "center",
      },
    ];
    const columnsTransaction = [
      {
        name: "symbol",
        label: "Symbol",
        field: "symbol",
        align: "center",
        style: "display:flex;max-width:100vw;justify-content: center;",
      },
      {
        name: "count",
        label: "No. of Transactions",
        field: "count",
        align: "center",
        sortable: true,
      },
      //   {
      //     name: "close",
      //     label: "LTP",
      //     field: "close",
      //     align: "center",
      //   },
    ];
    const columnsVolume = [
      {
        name: "symbol",
        label: "Symbol",
        field: "symbol",
        align: "center",
        style: "display:flex;max-width:100vw;justify-content: center;",
      },
      {
        name: "volume",
        label: "Shares Traded",
        field: "volume",
        align: "center",
        format: (val, row) => {
          return amountConversion(val);
        },
      },
      {
        name: "close",
        label: "LTP",
        field: "close",
        align: "center",
      },
    ];

    return {
      activeTabColorFromUtils,
      tablethreadColor,
      chooseActiveTabColor,
      chooseColorFromUtils,
      tabTurnover: ref("top_turnover"),
      columnsTurnover,
      columnsVolume,
      columnsTransaction,
    };
  },
};
</script>
